export default "__VITE_PUBLIC_ASSET__c3d61f74__"